/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { func, string, bool, arrayOf, shape } from 'prop-types';

import '../Selector/selector.scss';

export default function SelectorTray({
  fullWidthTray,
  headerText,
  elements = [],
  onSelect = () => {},
  alignment
}) {
  return (
    <div
      data-testid="select-tray-component"
      className={`selector-tray sdp-card ${fullWidthTray ? 'w-100' : ''}`}
      style={alignment === 'right' ? { right: 0 } : { left: 0 }}
    >
      {headerText && <p className="selector-tray-title">{headerText}</p>}
      <ul>
        {elements &&
          elements.map((el) => (
            <li
              className="selector-item"
              onClick={() => onSelect(el)}
              value={el.value}
              key={el.value}
            >
              {el.icon && (
                <p className="selector-item-icon icon-border">{el.icon}</p>
              )}
              <p
                className={`selector-item-name
                  }`}
              >
                {el.name}
              </p>
            </li>
          ))}
      </ul>
    </div>
  );
}

SelectorTray.propTypes = {
  elements: arrayOf(shape({})),
  onSelect: func,
  headerText: string,
  fullWidthTray: bool,
  alignment: string
};

SelectorTray.defaultProps = {
  elements: [],
  onSelect: () => {},
  headerText: '',
  fullWidthTray: false,
  alignment: 'right'
};
